// Central SEO + business configuration for AM Facilities.
// Single source of truth for per-route meta tags, canonical URLs and JSON-LD.

export const SITE_URL = 'https://www.amfacilities.ca';
export const SITE_NAME = 'AM Facilities';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const BUSINESS = {
  name: SITE_NAME,
  legalName: 'AM Facilities',
  founder: 'Anna Maia',
  telephone: '+1-647-675-2000',
  email: 'anna.maia@amfacilities.ca',
  areaServed: ['Toronto', 'Greater Toronto Area', 'GTA', 'Ontario'],
  sameAs: [
    'https://www.instagram.com/amfacilities',
    'https://g.page/r/CbK8FSvoU3W0EBM/review',
  ],
};

// Per-route SEO. Keys are the client-side route paths used in AMFacilities.js.
export const ROUTES = {
  '/': {
    path: '/',
    title: 'House, Condo & Office Cleaning in Toronto & the GTA | AM Facilities',
    description:
      'AM Facilities provides professional house, condo and office cleaning plus home maintenance inspections across Toronto and the GTA. Get a free quote in seconds.',
  },
  '/house-cleaning': {
    path: '/house-cleaning',
    title: 'House Cleaning Services in Toronto & the GTA | AM Facilities',
    description:
      'Deep, recurring and move-in/move-out house cleaning in Toronto and the GTA. Insured professionals, eco-friendly products and a spotless, healthier home. Free quote.',
  },
  '/condo-cleaning': {
    path: '/condo-cleaning',
    title: 'Condo Cleaning Services in Toronto & the GTA | AM Facilities',
    description:
      'Professional condo cleaning in Toronto and the GTA — dusting, vacuuming, kitchen and bathroom sanitization. One-time or recurring plans. Book your free quote today.',
  },
  '/office-cleaning': {
    path: '/office-cleaning',
    title: 'Office & Commercial Cleaning in Toronto & the GTA | AM Facilities',
    description:
      'Reliable office and commercial cleaning in Toronto and the GTA. Desk, floor, restroom and breakroom care for a healthier, more productive workplace. Free quote.',
  },
  '/home-maintenance': {
    path: '/home-maintenance',
    title: 'Home Maintenance Inspections in Toronto & the GTA | AM Facilities',
    description:
      'Proactive home maintenance inspections that cut repair costs and prevent system failures. Protect your home across Toronto and the GTA with AM Facilities.',
  },
  '/terms': {
    path: '/terms',
    title: 'Terms & Conditions | AM Facilities',
    description: 'Terms and conditions for AM Facilities cleaning and home inspection services.',
    noindex: true,
  },
};

export function getRouteMeta(pathname) {
  return ROUTES[pathname] || ROUTES['/'];
}

export const ALL_ROUTE_PATHS = Object.keys(ROUTES);
